export class Accordion {
    private _accordionElement: HTMLElement;
    private _accordionTitleElement: HTMLElement;
    private _accordionContentElement: HTMLElement;
    private _isActive: Boolean;

    constructor(accordionElement: HTMLElement) {
        this._accordionElement = accordionElement;

        

        if (this._accordionElement) {
            this._isActive = this._accordionElement.getAttribute('data-active') === "true";
            this._accordionTitleElement = this._accordionElement.querySelector('[data-title]');
            this._accordionContentElement = this._accordionElement.querySelector('[data-content]');
        }
    }

    public init = async () => {
        if (this._accordionTitleElement) {
            this._accordionTitleElement.addEventListener('click', (event) => {
                if (this._isActive) {
                    this._isActive = false;
                } else {
                    this._isActive = true;
                }

                this._accordionElement.setAttribute('data-active', this._isActive.toString());
                this._accordionContentElement.setAttribute('data-active', this._isActive.toString());
            });
        }
    }
}